import { createTheme as createMuiTheme } from '@material-ui/core/styles';

export const ToorakLightTheme = createMuiTheme({
  overrides: {
    MuiButton: {
      root: {
        textTransform: "none", //remove capitalization for all button
        "&.$Mui-disabled": {
          cursor: "no-drop !important"
        }
      },
      iconSizeMedium: {
        fontSize: "16px"
      },
      contained: { //default purple button
        backgroundColor: "#5f72e4",
        color: "#ffffff",
        "&:active": {
          boxShadow: "none",
        },
        "&:hover": {
          backgroundColor: "#3d55df",
        },
        "&.$Mui-disabled": {
          backgroundColor: "#3d55df",
          color: "#ffffff !important",
          opacity: "0.5",
          cursor: "no-drop !important"
        }
      },
      containedPrimary: { // white button
        backgroundColor: "#ffffff",
        margin: "0px 10px",
        color: "#32325d",
        "&:hover": {
          backgroundColor: "#dfe1e6",
        },
        "&.$Mui-disabled": {
          backgroundColor: "#dfe1e6",
          color: "#32325d !important",
          opacity: "0.5",
          cursor: "no-drop !important"
        }
      },
      containedSecondary: { // green button
        backgroundColor: "#2ece89",
        color: "#ffffff",
        "&:hover": {
          backgroundColor: "#29ae74",
        },
        "&.$Mui-disabled": {
          backgroundColor: "#29ae74",
          color: "#ffffff !important",
          opacity: "0.5",
          cursor: "no-drop !important"
        }
      },
      text: {
        color: "#32325d",
        padding: "0",
        "&:active": {
          color: "#3d55df",
        },
        "&:hover": {
          color: "#5e72e4",
          background: "none"
        },
      }
    },
    MuiAppBar: {
      colorDefault: {
        backgroundImage: "linear-gradient(93deg, #0fcbef 4%, #1071ee 90%)",
        // backgroundImage: "linear-gradient(90deg, #014DB0 55%, #009BC9 90%)",
        padding: "12px 20px 12px 12px",
        boxShadow: "none"
      }
    },
    MuiChip: {
      root: {
        borderRadius: "6px",
        textTransform: "uppercase",
        fontSize: "10px",
        fontWeight: "bold",
        height: "21px",
        color: "#ffffff"
      }
    }
  },
  props: {
    MuiButtonBase: {
      disableRipple: true
    }
  }
});

export const ToorakDarkTheme = createMuiTheme({
  overrides: {
    MuiButton: {
      root: {
        textTransform: "none", //remove capitalization for all button
      },
      iconSizeMedium: {
        fontSize: "16px"
      },
      contained: { //default purple button
        backgroundColor: "#5566d6",
        color: "#ffffff",
        "&:active": {
          boxShadow: "none",
        },
        "&:hover": {
          backgroundColor: "#3d55df",
        },
        "&.$Mui-disabled": {
          backgroundColor: "#3d55df",
          color: "#ffffff",
          opacity: "0.5"
        },
        '&$focusVisible': {
          border: "solid 1px #387eff",
          borderRadius: "6px"
        },
      },
      containedPrimary: { // white button
        backgroundColor: "#ffffff",
        margin: "0px 10px",
        color: "#32325d",
        "&:hover": {
          backgroundColor: "#dfe1e6",
        },
        "&.$Mui-disabled": {
          backgroundColor: "#dfe1e6",
          color: "#32325d",
          opacity: "0.5"
        }
      },
      containedSecondary: { // green button replaced with purple button
        backgroundColor: "#5566d6",
        color: "#ffffff",
        "&:hover": {
          backgroundColor: "#3d55df",
        },
        "&.$Mui-disabled": {
          backgroundColor: "#3d55df",
          color: "#ffffff",
          opacity: "0.5"
        }
      },
      text: {
        color: "#32325d",
        padding: "0",
        "&:active": {
          color: "#3d55df",
        },
        "&:hover": {
          color: "#5e72e4",
          background: "none"
        },
      }
    },
    MuiAppBar: {
      colorDefault: {
        backgroundColor: "#172b4e",
        padding: "12px"
      }
    },
  },
  props: {
    MuiButtonBase: {
      disableRipple: true
    }
  }
});